import React from 'react';
import ChatContainer from "./ChatContainer";

const ChatOpen = ({onClickClose, onChangeSearch, onChangeSearchValue, chat, newClientMessages, newInterneMessages, openSpecificChat, openSpecificRole}) => {
	return (
		<div className={"section-chat-is-open"}>
			<ChatContainer onClickClose={onClickClose}
			               chat={chat}
			               name={"Recherche"}
			               onChangeSearch={onChangeSearch}
			               onChangeSearchValue={onChangeSearchValue}
			               newInterneMessages={newInterneMessages}
			               newClientMessages={newClientMessages}
						   openSpecificChat={openSpecificChat}
						   openSpecificRole={openSpecificRole}
			/>
		</div>
	);
};

export default ChatOpen;
